import React, { useEffect, useState } from "react";
import { Card, Col, Stack } from "react-bootstrap";
import { patchBed } from "../../services/httpClient";
import SelectObjectTypeahead from "../ui/SelectObjectTypeahead";

interface CardState {
  item: any;
  getItems: any;
  beds: any;
  possibleOccupants: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const BedAssignmentCard = ({
  item,
  getItems,
  beds,
  possibleOccupants,
  setErrMessage,
  setShowToast,
  setToastText,
  setToastBody,
}: CardState) => {
  const [selectedOccupant, setSelectedOccupant] = useState<any>();
  const [occupants, setOccupants] = useState<any[]>([]);

  useEffect(() => {
    const vacant = {
      value: 0,
      label: "Vacant",
      original: { id: 0, key: 0, name: "Vacant" },
    };

    const unassignedOccupants = possibleOccupants
      .filter((p: any) => !p.hasBed)
      .map((p: any) => ({ value: p.key, label: p.name, original: p })
    );

    const assignedOccupants = possibleOccupants
      .filter((p: any) => p.hasBed)
      .map((p: any) => ({ value: p.key, label: p.name, original: p })
    );

    const occupants = [
      vacant,
      ...unassignedOccupants,
      { label: "Reassign", options: assignedOccupants },
    ];
    
    const flat = [vacant, ...unassignedOccupants, ...assignedOccupants];
    const selected = flat.find((i: any) => i.value === item.occupant_id + item.occupant_type);
    setOccupants(occupants);
    setSelectedOccupant(selected);
  }, [item, possibleOccupants]);

  const updateSelectedOccupant = (e: any) => {
    setErrMessage("");
    setSelectedOccupant(e);

    const updatedBed = {
      occupant_id: e.id,
      occupant_type: e.type,
    };

    patchBed(updatedBed, item?.id)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Bed Assigned");
        setToastBody(e?.hasBed ? "Reassigned " + e.name : e.name);
        getItems(true);
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  return (
    <Card key={item.name} className="bg-light mb-0">
      <Card.Body className="p-2">
        <Stack direction="horizontal" gap={3}>
          <Stack gap={2} className="align-self-center">
            {item?.room_name && <small className="text-muted">{item?.room_name}</small>}
            <small>{item?.name}</small>
          </Stack>
          <Col xs={6}>
            <SelectObjectTypeahead
              label="Occupant"
              value={selectedOccupant}
              options={occupants}
              onUpdate={(e: any) => updateSelectedOccupant(e)}
              groupHeading={true}
            />
          </Col>
        </Stack>
      </Card.Body>
    </Card>
  );
};

export default BedAssignmentCard;
